<template>
  <Drawer width="500" v-model="drawerOpened" :title="semiItem.material ? semiItem.material.model : ''">
    <div class="drawer-wrap">
      <div class="drawer-contetn">
        <div class="basic-info">
          <h3 class="basicInfo-item mlName">
            {{
              semiItem.material
                ? semiItem.material.model + "-" + semiItem.material.name
                : ""
            }}
          </h3>
          <div class="basicInfo-item">
            <div>配方名称</div>
            <div>
              {{
                currentMLLatestCost.recipeSemi
                  ? currentMLLatestCost.recipeSemi.name
                  : ""
              }}
            </div>
          </div>
          <div class="basicInfo-item">
            <div>创建时间</div>
            <div>
              {{
                currentMLLatestCost.recipeSemi
                  ? currentMLLatestCost.recipeSemi.createdAt
                  : ""
              }}
            </div>
          </div>
          <div class="basicInfo-item">
            <div>配方创建者</div>
            <div>
              {{
                currentMLLatestCost.recipeSemi
                  ? currentMLLatestCost.recipeSemi.createdBy.name
                  : ""
              }}
            </div>
          </div>
          <div class="basicInfo-item">
            <div>生产工厂</div>
            <div>
              {{ semiItem.factory ? semiItem.factory.name : "" }}
            </div>
          </div>
          <div class="basicInfo-item materialCost">
            <div>材料成本</div>
            <div>{{ parseInt(currentMLLatestCost.materialCost) }}</div>
          </div>
          <div class="basicInfo-item manufactCost">
            <div>合成加工费</div>
            <div>{{ currentMLLatestCost.manufactCost }}</div>
          </div>
          <div class="basicInfo-item materialAddManufact">
            <div>材料+制造合计</div>
            <div>
              {{
                parseInt(
                  currentMLLatestCost.manufactCost +
                  currentMLLatestCost.materialCost
                )
              }}
            </div>
          </div>
          <div class="basicInfo-item tranCost">
            <div>运费</div>
            <div>
              {{
                currentMLLatestCost.importSemiTransCost
                  ? currentMLLatestCost.importSemiTransCost
                  : "-"
              }}
            </div>
          </div>
          <div class="basicInfo-item totalCost">
            <div>总成本</div>
            <div>{{ parseInt(currentMLLatestCost.totalCost) }}</div>
          </div>
          <div class="basicInfo-item totalCost">
            <div>固含量</div>
            <div>{{ currentMLLatestCost.solidContent.toFixed(2) + "%" }}</div>
          </div>
          <div class="basicInfo-item totalCost">
            <div>单个固含成本</div>
            <div>
              {{ currentMLLatestCost.unitCostPerSoidContent.toFixed(2) }}
            </div>
          </div>
        </div>

        <div class="cost"></div>
        <div class="material-table">
          <Table border :loading="materialTableLoading" :columns="materialTableColumns"
            :data="currentMLLatestCost.materialCostDetail">
          </Table>
        </div>
      </div>
    </div>
  </Drawer>
</template>

<script>
import { mapState, mapActions } from "vuex";
import dayjs from "dayjs";

export default {
  name: "CaclMLDetailDrawer",
  data() {
    return {
      drawerOpened: false,
      currentMLLatestCost: {},
      materialTableLoading: false,
      materialTableColumns: [
        {
          title: "材料",
          key: "material",
          align: "left",
          minWidth: 130,
          render: (h, params) => {
            return h(
              "div",
              {
                style: {
                  fontSize: 16,
                },
              },
              params.row.material.model
                ? params.row.material.model
                : params.row.material.name
            );
          },
        },
        {
          title: "比例",
          key: "ratio",
          align: "right",
          width: 100,
          render: (h, params) => {
            return h(
              "div",
              params.row.ratio ? (params.row.ratio * 100).toFixed(2) + "%" : ""
            );
          },
        },
        {
          title: "单价",
          key: "materialCost",
          align: "right",
          render: (h, params) => {
            return h(
              "div",
              params.row.calcPurchaseUnitCost
                ? parseInt(params.row.calcPurchaseUnitCost)
                : ""
            );
          },
        },
        {
          title: "价格",
          key: "materialCost",
          align: "right",
          render: (h, params) => {
            return h("div", parseInt(params.row.materialCost));
          },
        },
      ],
      semiItem: {},
    };
  },
  methods: {
    ...mapActions({
      getSemiLatestCostDetail: "calcSemiCost/getSemiLatestCostDetailAction",
    }),
    async openDrawer(semiItemId) {
      this.currentMLLatestCost = {};
      this.drawerOpened = true;
      try {
        this.semiItem = await this.getSemiLatestCostDetail(semiItemId);
        if (!this.semiItem || !this.semiItem.calcSemiCost) {
          throw new Error();
        }
      } catch (error) {
        return this.$Message.error("获取成本核算错误");
      }

      const data = this.semiItem.calcSemiCost;
      data.recipeSemi.createdAt = dayjs(data.recipeSemi.createdAt).format(
        "YYYY-MM-DD HH:mm"
      );
      const total = { material: {}, materialCost: null };
      total.material.model = "材料合计";
      total.materialCost = data.materialCost;
      total.ratio = data.materialCostDetail.reduce((p, c) => {
        return p + c.ratio;
      }, 0);

      data.materialCostDetail.push(total);
      this.currentMLLatestCost = data;
    },
  },
};
</script>

<style scoped lang="stylus">
.drawer-wrap
  padding 20px
  font-size 16px

.basic-info
  padding 0 20px 0 20px
  margin-bottom 20px

.basicInfo-item
  display flex
  justify-content space-between
  margin-bottom 7px
  border-bottom 1px solid rgba(0, 0, 0, 0.05)

.cost-item
  display flex
  justify-content space-between
  margin 5px 0 5px 0
  padding 0 20px 0 20px
</style>